import { FolderOpen, Pencil, Trash2, MoreVertical } from "lucide-react";
import { resolveMediaCar } from "../../services/api";
import defaultAvatar from "../../assets/logo/logo.png";
import { useState, useRef, useEffect } from "react";

export default function CarRow({ car, onToggleApprove, onDelete, onView, onEdit }) {
  const customerUser = car.customer?.user;
  const avatar = resolveMediaCar(car.photo, defaultAvatar);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <tr>
      <td>
        <div className="userCell">
          <img src={avatar} className="tableAvatar carThumb" alt="voiture" />
          <div>
            <div className="userName">{car.marque} {car.modele}</div>
            <div className="userSub">{car.matricule}</div>
          </div>
        </div>
      </td>
      <td>
        <div className="ownerInfo">
          <div className="userName">{customerUser?.firstName} {customerUser?.lastName}</div>
          <div className="userSub">{customerUser?.contact?.tel || "N/A"}</div>
        </div>
      </td>
       <td>
        <div className="ownerInfo">
          <div className="userName">{car.isManual ? "Manuelle" : "Automatique"}</div>
          <div className="userSub">{car.isEssence ? "Essence" : "Diesel"}</div>
        </div>
      </td>
      <td className="center">
        <Switch 
          checked={car.isApproved} 
          onChange={() => onToggleApprove(car)} 
        />
      </td>
      {/* <td className="center">
        <div className="actionsMenu" ref={menuRef}>
          <button className="iconBtn" onClick={() => setOpen(!open)}>
            <MoreVertical size={18} />
          </button>

          {open && (
            <div className="dropdownActions">
              <button onClick={() => { onView?.(car); setOpen(false); }}>
                <FolderOpen size={16} /> Détails
              </button>

              <button onClick={() => { onEdit?.(car); setOpen(false); }}>
                <Pencil size={16} /> Modifier
              </button>

              <button className="danger" onClick={() => { onDelete?.(car); setOpen(false); }}>
                <Trash2 size={16} /> Supprimer
              </button>
            </div>
          )}
        </div>
      </td> */}
    </tr>
  );
}

function Switch({ checked, onChange }) {
  return (
    <label className="switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider" />
    </label>
  );
}